import React from "react";
import "./AchievementCard.scss";

export default function AchievementCard({cardInfo, isDark}) {
  return (
    <div className={isDark ? "dark-mode certificate-card" : "certificate-card"}>
      <div className="certificate-card-header">
        <div
          className={
            isDark ? "certificate-logo-div dark-logo-bg" : "certificate-logo-div"
          }
        >
          <img
            src={cardInfo.image}
            alt={cardInfo.imageAlt || "Card Thumbnail"}
            className="card-image"
          ></img>
        </div>
        <h3 className={isDark ? "dark-mode card-title" : "card-title"}>
          {cardInfo.title}
        </h3>
      </div>
      <p className={isDark ? "dark-mode card-subtitle" : "card-subtitle"}>
        {cardInfo.description}
      </p>
      <div className="certificate-card-footer">
        {cardInfo.footer.map((v, i) => {
          return (
            <a
              key={i}
              className={
                isDark ? "dark-mode certificate-tag" : "certificate-tag"
              }
              href={v.url}
              target="_blank"
              rel="noopener noreferrer"
            >
              {v.name} <i className="fas fa-external-link-alt" aria-hidden="true"></i>
            </a>
          );
        })}
      </div>
    </div>
  );
}
